import { MenuItem, Typography, useTheme } from '@mui/material'
import { NavLink } from 'components/nav-link'
import { CSSProperties } from 'react'

type Props = {
  onClick?: () => void
  to: string
  title: string
  match?: boolean
  styles?: CSSProperties
}

export const NavItem = ({ onClick, to, title, match, styles }: Props) => {
  const theme = useTheme()

  return (
    <MenuItem
      onClick={onClick}
      sx={{
        backgroundColor: match ? theme.palette.action.selected : undefined,
        '&:hover': {
          backgroundColor: match
            ? theme.palette.action.selected
            : theme.palette.action.hover,
        },
      }}
    >
      <NavLink to={to}>
        <Typography
          sx={{
            color: match ? theme.palette.primary.main : undefined,
            ...styles,
          }}
        >
          {title}
        </Typography>
      </NavLink>
    </MenuItem>
  )
}
